import React from "react";
import { useGetMyPermissionsQuery } from "../../../../Redux/service/Roles&Permissions/RolesPermissions";
import trans from "../../../../utils";
import { Checkbox } from "antd";

export default function RolesPermissions({ values }) {
	const { data: PermissionsData } = useGetMyPermissionsQuery(
		{ userType: values?.userType },
		{ skip: !values?.userType },
	);
	return (
		<>
			<p className="fs-16 fw-700 brand-700 text-uppercase mt-2">
				{trans("permissions")}
			</p>
			<div className="row">
				{PermissionsData?.data?.map((i) => (
					<div className="col-lg-4 mb-" key={i.id}>
						<div className="d-flex align-items-center">
							<Checkbox
								checked={values?.rolePermissions?.some(
									(permission) => permission?.permission?.id === i.id,
								)}
								disabled={
									!values?.rolePermissions?.some(
										(permission) => permission?.permission?.id === i.id,
									)
								}
							/>
							<div className="mx-2 text-capitalize" style={{ fontSize: 12 }}>
								{`${i.actions} ${i.name}`}
							</div>
						</div>
					</div>
				))}
			</div>
		</>
	);
}
